import { WALLET_CODE } from './wallet.interfaces';

export interface IRewardsPointsProgram {
  _id?: string;
  user_id?: string;
  type: REWARDS_POINTS_PROGRAM_TYPE;
  status: REWARDS_POINTS_PROGRAM_STATUS;
  amount: number;
  /*
  this transaction_id correspond to:
    account_movements_id
    deposit_id
    reward_game_id
    gameSessions_id
    sportsSession_id
    drawUserBets_id
  */
  transaction_id: string;
  created_at: number;
  expires_at?: number;
  wallet: WALLET_CODE;
  balance?: number;
}
export enum REWARDS_POINTS_PROGRAM_TYPE {
  CONVERTED = 'CONVERTED',
  DEPOSIT = 'DEPOSIT',
  REFERRAL = 'REFERRAL',
  LUCKY_CELLS = 'LUCKY_CELLS',
  CASINO = 'CASINO',
  SPORTS = 'SPORTS',
  BICHO = 'BICHO',
  WELCOME = 'WELCOME',
}

export enum REWARDS_POINTS_PROGRAM_STATUS {
  ACTIVE = 'ACTIVE',
  // CONVERTED = 'CONVERTED',
  CANCELLED = 'CANCELLED',
  EXPIRED = 'EXPIRED',
}
